module.exports = "/assets/1ce585852b9e9a8cba36762b911e0f5f.png";